import { render, staticRenderFns } from "./chainSupplierManage.vue?vue&type=template&id=5b97a9b1&scoped=true"
import script from "./chainSupplierManage.vue?vue&type=script&lang=js"
export * from "./chainSupplierManage.vue?vue&type=script&lang=js"
import style0 from "./chainSupplierManage.vue?vue&type=style&index=0&id=5b97a9b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97a9b1",
  null
  
)

export default component.exports